<template>
    <div>
        <rkm-table
            :items="model.items"
            :fields="fields"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(prescrito)="{ item }">
                <template v-if="item.continuo">
                    Continuo
                </template>
                <template v-else>
                    {{ item.prescrito }}
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.observacao ? 'info' : 'secondary'"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Observação',
                        html:true,
                        content: item.observacao
                            ? item.observacao
                            : 'Nenhuma observação informada.',
                    }"
                >
                    <i class="fas fa-comment-alt"></i>
                </rkm-button>

                <rkm-button
                    @click.stop="edit(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="remove(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Mixins
import { object, data } from '@/mixins'

import functions from '@/utils/farmacia/functions'

//Moment
import moment from 'moment'

export default {
    computed: {
        fields() {
            return [
                { label: "Item", key: "material.descricaoCompleta", searchable: true },
                { label: "Programa", key: "programa", searchable: true },
                { label: "Prescrito", key: "prescrito", searchable: true },
                { label: "Entregue", key: "entregue", searchable: true },
                { label: "Próxima retirada", key: "proximaRetirada", searchable: true },
                { label: "Ações", key: "actions", searchable: true, class: "col-min" },
            ]
        },
    },
    created() {

        if (this.model) {

            this.defaultItem = this.clone(this.model.item)
        }
    },
    data: () => ({
        defaultItem: null
    }),
    methods: {
        ...functions,
        add() {

            this.model.item = this.clone(this.defaultItem)
            this.$refs.ModalItem.open(this.clone(this.form), this.clone(this.model))
        },
        edit(item) {
            const itemClone = this.clone(item)

            itemClone.proximaRetirada = moment(itemClone.proximaRetirada, 'DD/MM/YYYY').format('YYYY-MM-DD')
            itemClone.dispensadoEm = moment(this.form.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')

            if (this.model.ambulatorioPrescricaoMedicamentoId) {
                this.$emit('remove-item-watchers')
            }

            this.$nextTick().then(() => this.model.item = itemClone)

            if (this.model.ambulatorioPrescricaoMedicamentoId) {
                this.$nextTick().then(() => this.$emit('add-item-watchers'))
            }
            // this.$refs.ModalItem.open(this.clone(this.form), this.clone(this.model))
        },
        handleSave(item) {

            const itemClone = this.clone(item)

            itemClone.proximaRetirada = this.getFormatedDate(item.proximaRetirada, 'DD/MM/YYYY', 'YYYY-MM-DD')
            itemClone.dispensadoEm = this.getFormatedDate(item.dispensadoEm, 'DD/MM/YYYY', 'YYYY-MM-DD')

            const hasMaterial = this.model.items.some(i => i.material.id == itemClone.material.id && i.id != item.id)
            if (hasMaterial) {

                this.showWarningNotification("Este item já está na lista!")

                return
            }

            if (itemClone.id) {

                const idx = this.model.items.findIndex(i => i.id === itemClone.id)
                Object.assign(this.model.items[idx], itemClone)

            } else {

                itemClone.id = `${new Date().getTime()}-receita-item`
                this.model.items.push(itemClone)
            }

            this.$emit('save', itemClone)
            this.$refs.ModalItem.close()
        },
        remove(item) {

            const remove = async () => {

                const idx = this.model.items.findIndex(i => i.id === item.id)
                this.model.items.splice(idx, 1)
            }

            this.showDeleteConfirmation(
                "Deseja realmente excluir o item da receita?",
                remove,
                async () => {},
            )
        },
    },
    mixins: [object, data],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>